'use client'

import { LinkButton } from '@/components/buttons'
import Link from '@/components/Link'

/** An internal route link, or a PDF opened on click. */
export type ProductDocLink = { text: string; href: string } | { text: string; pdf: string }

interface ProductDocumentLinksProps {
  items: ProductDocLink[]
}

/**
 * The repeated product "document links" row (Terms, e-Application, rate/fee
 * PDFs) found on ~30 product pages. Internal routes render as a wrapped
 * <Link><LinkButton/>; PDF entries render an anchor via LinkButton's `pdf`. Emits identical
 * markup to the hand-written `link-button-row` blocks it replaces.
 */
function ProductDocumentLinks({ items }: ProductDocumentLinksProps) {
  return (
    <div className="link-button-row">
      {items.map((item, index) =>
        'href' in item ? (
          <Link key={index} href={item.href} className="w-full">
            <LinkButton text={item.text} />
          </Link>
        ) : (
          <LinkButton key={index} text={item.text} pdf={item.pdf} />
        )
      )}
    </div>
  )
}

export default ProductDocumentLinks
